import { IToastConfig } from 'src/common/primitives/Toast';

export function generateAddSuccessToast(id: number): IToastConfig {
  return {
    id,
    title: `An assignment has been added!`,
  };
}
